import React from 'react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { useAccountListsV2 } from '@/dashboard/AccountListsV2/hooks/useAccountListsV2';
import { styled, Button, Icons } from '@/theme/index';

export interface ListPropertyCtaProps {
  savedReportOnList: boolean;
  savedReportListCode: string;
  listPropertyIDs: string[];
  zipcode: string;
  address: string;
  city: string;
  state: string;
}

const CtaButton = styled(Button)(() => ({
  zIndex: '2',
  position: 'relative',
  border: 'none',
  background: 'transparent',

  '&:hover': {
    background: 'transparent',
  },
}));

const CtaFilledImage = styled(Icons.Favorite)(({ theme }) => ({
  opacity: '1',
  color: theme.palette.error.main,
}));

const CtaImage = styled('img')(({ theme }) => ({
  opacity: '0.8',
  color: theme.palette.background.paper,
  '&:hover': {
    opacity: '1',
  },
}));

export function ListPropertyCta({
  savedReportOnList,
  savedReportListCode,
  listPropertyIDs,
  zipcode,
  address,
  city,
  state,
}: ListPropertyCtaProps) {
  const { bulkDeleteListProperty, bulkAddListProperty } = useAccountListsV2();
  const {
    images: { imgSaveListProperty },
  } = useAppConstantsContext();

  const property = [{ street: address, city, zip5: zipcode, state }];

  const handleCtaClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    if (savedReportOnList) {
      bulkDeleteListProperty.mutate({
        list_code: savedReportListCode,
        propertyIDs: listPropertyIDs,
      });
    } else {
      bulkAddListProperty.mutate({
        list_code: savedReportListCode,
        properties: property,
      });
    }
  };

  return (
    <CtaButton
      data-testid="list-property-cta"
      onClick={(e) => handleCtaClick(e)}
    >
      {savedReportOnList ? (
        <CtaFilledImage />
      ) : (
        <CtaImage src={imgSaveListProperty} />
      )}
    </CtaButton>
  );
}
